import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';

export interface ICountry {
  id: number;
  name: string;
}

export interface ICountryListResponse {
  countries: ICountry[] | [];
}

export const getCountryList = async (): Promise<ICountryListResponse> => {
  try {
    const config = {
      url: 'landing/countryList',
      method: 'GET',
      baseURL: ENV_VARS.API_URL,
    };
    const res = await kf1AuthenticatedHttpClient(config);
    return res.data;
  } catch (error) {
    console.error('Error fetching country list:', error);
    throw error;
  }
};
